import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import type { IconProps } from 'vuetify'
import { h } from 'vue'
import { de, en } from 'vuetify/locale'

// Custom icons
import ZamgPin from '@/components/icons/ZamgPin.vue'
import ZamgPinAdd from '@/components/icons/ZamgPinAdd.vue'
import ZamgPinRemove from '@/components/icons/ZamgPinRemove.vue'
import ZamgPinCoord from '@/components/icons/ZamgPinCoord.vue'
import ZamgRectangle from '@/components/icons/ZamgRectangle.vue'
import ZamgRectangleAdd from '@/components/icons/ZamgRectangleAdd.vue'
import ZamgRectangleRemove from '@/components/icons/ZamgRectangleRemove.vue'
import ZamgRectangleCoord from '@/components/icons/ZamgRectangleCoord.vue'
import ZamgRectangleTemplate from '@/components/icons/ZamgRectangleTemplate.vue'

const customIcons = {
  zamgPin: ZamgPin,
  zamgPinAdd: ZamgPinAdd,
  zamgPinRemove: ZamgPinRemove,
  zamgPinCoord: ZamgPinCoord,
  zamgRectangle: ZamgRectangle,
  zamgRectangleAdd: ZamgRectangleAdd,
  zamgRectangleRemove: ZamgRectangleRemove,
  zamgRectangleCoord: ZamgRectangleCoord,
  zamgRectangleTemplate: ZamgRectangleTemplate,
} as const

const customSet = {
  component: (props: IconProps) => {
    const iconName = props.icon as keyof typeof customIcons
    const IconComponent = customIcons[iconName]
    if (!IconComponent) return null
    return h(props.tag, props, [h(IconComponent, { ...props })])
  },
}

const customAliases = {
  ...aliases,
}

export const colors = {
  primary: '#052E37',
  'primary-lighten1': '#546d73',
  'primary-lighten2': '#9dabae',
  'primary-lighten3': '#dae0e1',
  secondary: '#BFCE40',
  'secondary-lighten1': '#d2dd65',
  'secondary-lighten2': '#e5eca3',
  'secondary-lighten3': '#f6f8dc',
  'text-input': '#052E37',
  'text-button': '#FFFFFF',
  'text-label': '#052E37',
  'text-disabled': '#dae0e1',
  scrim: '#B2B3C0',
  divider: '#dae0e1',
  container: '#FFFFFF',
  background: '#FFFFFF',
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          ...colors,
        },
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases: customAliases,
    sets: {
      mdi,
      custom: customSet,
    },
  },
  defaults: {
    VIcon: {
      size: 24,
    },
  },
  locale: {
    locale: 'de',
    messages: { de, en },
  }
})
